<template>
  <div class="box white p-3 mb-3">
    <K2Row space-between="true">
      <K2Text bold="true" class-name="mb-3" :style="{ fontSize: uiVariable.fontSize.lg }">{{ lang('Media') }}</K2Text>
      <K2Row>
        <K2Button
          size="small"
          theme="2"
          class="me-2"
          :class-name="isRearrange && 'text-white'"
          :background="isRearrange === true ? uiVariable.color.purple : uiVariable.color.backgroundGrey2"
          @onclick="handleArrange()"
          >{{ lang('Rearrange') }}
        </K2Button>
        <K2Button size="small" theme="2" class="me-2" @onclick="onclickUploadFile()">{{ lang('Browse') }} </K2Button>
        <input type="file" id="fileUpload" @change="onFileChanged" multiple hidden="hidden" />
        <K2Icon color="black" name="expand_less" class="when-open" />
        <K2Icon color="black" name="expand_more" class="when-closed" />
      </K2Row>
    </K2Row>
    <b-collapse id="media" visible>
      <div class="row" style="min-height: 200px">
        <div
          class="col-md-4 mediaItem mb-3"
          v-for="(selFile, i) in selectedFile"
          :key="i"
          :draggable="isRearrange"
          @dragstart="dragStart(i, $event)"
          @dragover.prevent
          @dragend="dragEnd"
          @drop="dragFinish(i, $event)"
        >
          <div class="box purple drag" :class="selFile.file.isArrange && 'active'">
            <!--if image-->
            <img v-if="checkIfImage(selFile.file)" style="height: 250px" class="w-100 m-0" crossorigin :src="selFile.url" />
            <!--if video-->
            <div
              class="media-file-video preview"
              v-if="!checkIfImage(selFile.file) && getFileExtention(selFile.file) !== 'pdf'"
              :class="'video-thumbnail-' + i"
              v-bind:ref="'video' + parseInt(i)"
            >
              <img class="preview" :src="assets.image.videoThumb" />
              <div class="lds-ellipsis" v-if="videoClick" style="top: 40%">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <!--if pdf-->
            <div class="media-file-video preview" v-if="!checkIfImage(selFile.file) && getFileExtention(selFile.file) === 'pdf'" :class="'pdf-thumbnail-' + i">
              <pdf class="media-file-video preview" :src="selFile.url" style="max-width: 100%; height: 256px; overflow: auto"></pdf>
            </div>
            <!--<K2Pdf style="max-width: 100%; overflow: auto;"-->
            <!--v-if="!checkIfImage(selFile) && selFile.type.toLowerCase() === 'application/pdf'"-->
            <!--v-bind:ref="'pdf'+parseInt( i )" :type="selFile.type.toLowerCase()"/>-->
            <K2Row class="media-action">
              <K2Button size="small" theme="2" @onclick="triggerClickVideo(selFile, i)" v-if="!checkIfImage(selFile.file)">{{ lang('View') }} </K2Button>
              <K2Button size="small" type="danger" @onclick="removeItemAt(i)">{{ lang('Delete') }} </K2Button>
              <K2Button size="small" theme="2" @onclick="replace(selFile.file, i)">{{ lang('Replace') }} </K2Button>
            </K2Row>
            <K2DatePicker v-model="selFile.date" v-if="passPostType !== 'Update'" />
          </div>
        </div>
      </div>
    </b-collapse>

    <K2Modal :fullscreen="false" :dialog="videoClick" @handleClose="handleClose" @onConfirm="handleClose" :hideFooter="true">
      <div class="pb-3">
        <video
          v-if="videoFile"
          class="media-file-video preview"
          style="max-width: 100%; height: 100%"
          controls
          autoplay
          :src="videoFile"
          type="video/mp4"
          controlsList="nodownload"
        ></video>
        <!--<embed v-else :src="pdfFile.url" frameborder="0" width="100%" height="400px">-->
        <pdf v-else-if="pdfFile" class="media-file-video preview" :src="pdfFile"></pdf>
      </div>
    </K2Modal>
  </div>
</template>

<script>
import K2Heading from '../../../../uiComponents/k2Heading/k2Heading'
import K2Icon from '../../../../uiComponents/k2Icon/k2MAIcon'
import K2Row from '../../../../uiComponents/k2Row/k2Row'
import uiVariable from '../../../../config/uiVariable'
import DataSource from '../../../../data/datasource'
import K2Button from '../../../../uiComponents/k2Button/k2Button'
import $ from 'jquery'
import K2Text from '../../../../uiComponents/k2Text/k2Text'
import assets from '../../../../assets/assets'
import K2Pdf from '../../../../uiComponents/k2Pdf/k2Pdf'
import K2Modal from '../../../../uiComponents/k2Modal/k2Modal'
import pdf from 'vue-pdf'
import { lang } from '../../../../locale'
import heic2any from 'heic2any'
import K2DatePicker from '../../../../uiComponents/k2Input/k2DatePicker'
import { getActivityUploadPreviewBase } from '@/helper/util_custom'
import moment from 'moment'

export default {
  name: 'activityMedia',
  components: { K2DatePicker, K2Modal, K2Pdf, K2Text, K2Button, K2Row, K2Icon, K2Heading, pdf },
  props: ['handleBack', 'passselectedfile', 'passPostType'],
  data() {
    return {
      assets: assets,
      uiVariable: uiVariable,
      search: '',
      arrobj_Levels: [],
      studentList: null,
      title: '',
      content: '',
      arr_SelectedFileList: [],
      arrobj_SelectedFiles: [],
      arrstr_Whitelist: [],
      selectedFile: [],
      isReplace: false,
      replaceIndex: '',
      dragging: -1,
      isRearrange: false,
      videoClick: false,
      videoFile: null,
      pdfFile: null,
      postType: null,
      maxFile: 20,
      uploading: false,
      percentage: 0,
    }
  },
  watch: {
    passselectedfile: function (value, oldval) {
      if (value) {
        this.arrobj_SelectedFiles = []
        this.selectedFile = []
        this.handleUpdateImage(value)
      }
    },

    passPostType: function (value, oldval) {
      if (value) {
        this.postType = value
      }
    },
  },
  mounted() {
    this.init()
    const self = this
    self.loadWhitelist()
    $('#fileUpload')
      .off('change')
      .on('change', function (e) {
        e.preventDefault()

        self.arr_SelectedFileList = []
        self.arr_SelectedFileList = e.target.files
        self.checkMaxFile(e)

        // if (e.target.files.length > 20) {
        //   self.$notify.error({
        //     title: "Error",
        //     message: "Upload files max allow 20 each time!"
        //   });
        //   this.selectedFile = [];
        // } else {
        //   self.showFilesTagModal();
        // }
      })
  },
  methods: {
    lang,
    init() {},
    async handleUpdateImage(value) {
      if (!this.isNull(value)) {
        let imageList = []
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        for (let image of value) {
          // let url = "data:" + image.PostItemFileType + ";base64," + image.PostItemFileLow;
          // let url = "data:" + image.PostItemFileType + ";base64," + image.PostItemFile;
          let numPages
          let date = image.PostItemDate || image.PostItemCreatedDate
          let url = image.FilePath
          if (image.numPages) {
            numPages = image.numPages
          }
          let fileName = image.ID + '-image' + image.PostItemFileExt
          let mimeType = image.PostItemFileType
          await this.urltoFile(url, fileName, mimeType).then(file => {
            file.url = url
            file.numPages = numPages
            imageList.push(file)
            this.arrobj_SelectedFiles.push({
              file,
              PostItemDate: date ? moment(date) : '',
            })
          })
        }

        DataSource.shared.uploadPostMedia(imageList).then(saveResponse => {
          saveResponse?.forEach((file, index) => {
            let date = value?.[index]?.PostItemDate
            this.selectedFile.push({
              file,
              date: date ? moment(date) : '',
              url: getActivityUploadPreviewBase() + '/' + file,
            })
          })
          loading.close()
        })
        this.$emit('getselectedfiles', this.selectedFile)
        // this.$emit("getselectedfiles", this.arrobj_SelectedFiles);
      }
    },
    getImagePreviews() {
      /*
          Iterate over all of the files and generate an image preview for each one.
        */
      for (let i = 0; i < this.selectedFile.length; i++) {
        /*
            Ensure the file is an image file
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.selectedFile[i].name)) {
          /*
              Create a new FileReader object
            */
          let reader = new FileReader()

          /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */

          reader.addEventListener(
            'load',
            function () {
              this.$refs['image' + parseInt(i)][0].src = reader.result
            }.bind(this),
            false,
          )

          /*
              Read the data for the file in through the reader. When it has
              been loaded, we listen to the event propagated and set the image
              src to what was loaded from the reader.
            */
          reader.readAsDataURL(this.selectedFile[i])
        }

        if (/\.(mp4|mp3|aac|wav|m4a|mov)$/i.test(this.selectedFile[i].name)) {
          /*
              Create a new FileReader object
            */
          let reader = new FileReader()
          /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */
          reader.addEventListener(
            'load',
            function () {
              // this.$refs['video' + parseInt(i)][0].src = reader.result;
              // this.$refs['video' + parseInt(i)][0].src = this.selectedFile[i].oriPath;
            }.bind(this),
            false,
          )

          /*
              Read the data for the file in through the reader. When it has
              been loaded, we listen to the event propagated and set the image
              src to what was loaded from the reader.
            */
          reader.readAsDataURL(this.selectedFile[i])
        }

        if (/\.(doc?x)$/i.test(this.selectedFile[i].name)) {
          /*
              Create a new FileReader object
            */
          let reader = new FileReader()

          /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */
          reader.addEventListener(
            'load',
            function () {
              this.$refs['image' + parseInt(i)][0].src = '../assets/docx-icon.png'
            }.bind(this),
            false,
          )

          /*
              Read the data for the file in through the reader. When it has
              been loaded, we listen to the event propagated and set the image
              src to what was loaded from the reader.
            */
          reader.readAsDataURL(this.selectedFile[i])
        }

        if (/\.(xls?x)$/i.test(this.selectedFile[i].name)) {
          /*
              Create a new FileReader object
            */
          let reader = new FileReader()

          /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */
          reader.addEventListener(
            'load',
            function () {
              this.$refs['image' + parseInt(i)][0].src = '../assets/excel-icon.png'
            }.bind(this),
            false,
          )

          /*
              Read the data for the file in through the reader. When it has
              been loaded, we listen to the event propagated and set the image
              src to what was loaded from the reader.
            */
          reader.readAsDataURL(this.selectedFile[i])
        }

        if (/\.(pdf)$/i.test(this.selectedFile[i].name)) {
          /*
              Create a new FileReader object
            */
          let reader = new FileReader()

          /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */
          reader.addEventListener(
            'load',
            function () {
              this.$refs['pdf' + parseInt(i)][0].src = reader.result
            }.bind(this),
            false,
          )

          /*
              Read the data for the file in through the reader. When it has
              been loaded, we listen to the event propagated and set the image
              src to what was loaded from the reader.
            */
          reader.readAsDataURL(this.selectedFile[i])
        }
      }
    },
    showLoading() {
      this.$vs.loading()
    },

    hideLoading() {
      this.$vs.loading.close()
    },
    onclickUploadFile() {
      if (this.selectedFile.length) {
      }
      $('#fileUpload').val('')
      $('#fileUpload').click()
    },
    checkMaxFile(event) {
      let currentFileLength = this.arr_SelectedFileList.length
      let totalFiles
      if (currentFileLength === 0) {
        totalFiles = event.target.files.length
      } else {
        totalFiles = currentFileLength + event.target.files.length
      }
      if (totalFiles > 20) {
        this.$notify.error({
          title: 'Error',
          message: 'Only max 20 file allow in a post.',
        })
      } else if (event.target.files.length > 20) {
        this.$notify.error({
          title: 'Error',
          message: 'Upload files max allow 20 each time!',
        })
      } else {
        // this.showFilesTagModal();
      }
    },
    async onFileChanged(event) {
      // this.$alert("fileclick");
      // if (!this.checkMaxFile(event)) {

      let tempSelectedFile = this.selectedFile
      if (event.target.files.length < this.maxFile) {
        // let heicList = [];
        // let imageList = [];
        // for (let d of event.target.files) {
        //   if (d.name.toLowerCase().indexOf(".heic") !== -1) {
        //     console.log("isHeicFound");
        //     heicList.push(d)
        //   }else{
        //     imageList.push(d)
        //   }
        // }
        // if(heicList.length>0){
        //   await this.handleHeic(heicList);
        // }
        if (event.target.files.length > 0) {
          const saveResponse = await DataSource.shared.uploadPostMedia(event.target.files)
          if (saveResponse) {
            for (let file of saveResponse) {
              // if (file.size > 10048576) {
              //   this.$notify.error({
              //     title: 'Error',
              //     message: 'File limit exceeded 10MB!'
              //   });
              // } else {

              // file.numPages = 1;
              if (this.isReplace) {
                if (this.selectedFile.length > 0) {
                  let arr = []
                  arr = this.selectedFile.map((d, i) => {
                    if (i === this.replaceIndex) {
                      d.file = file
                      d.url = getActivityUploadPreviewBase() + '/' + file
                    }
                    return d
                  })
                  this.selectedFile = arr
                }
              } else {
                tempSelectedFile.push({ file, date: '', url: getActivityUploadPreviewBase() + '/' + file })
              }

              this.$forceUpdate()

              // }
            }
          }
        }
      }
      // }
      if (!this.isReplace) {
        this.selectedFile = tempSelectedFile
      } else {
        this.isReplace = false
      }

      this.$emit('getselectedfiles', this.selectedFile)
    },
    showFilesTagModal() {
      for (let a = 0; a < this.arr_SelectedFileList.length; a++) {
        if (this.isWhitelist(this.arr_SelectedFileList[a])) {
        } else {
          this.$notify.error({
            title: 'Error',
            message: lang('File with invalid format selected'),
          })
          return
        }
      }

      this.changeSelectedFilesFormat()
    },
    async changeSelectedFilesFormat() {
      // this.showLoading();
      // this.arrobj_SelectedFiles = [];
      for (let a = 0; a < this.arr_SelectedFileList.length; a++) {
        var blobUrl = URL.createObjectURL(this.arr_SelectedFileList[a])

        if (this.arr_SelectedFileList[a].name.toLowerCase().indexOf('.heic') !== -1) {
          this.showLoading()

          await this.heicToJpeg(this.arr_SelectedFileList[a])
            .then(convertedFile => {
              this.handlePushMedia(convertedFile)
            })
            .finally(() => {
              this.hideLoading()
              // this.arrobj_SelectedFiles.push(this.arr_SelectedFileList[a]);
            })
        }
        // else {
        //   this.handlePushMedia(this.arr_SelectedFileList[a]);
        // }

        // this.arrobj_SelectedFiles.push(this.arr_SelectedFileList[a]);
      }
      await this.convertSelectedFilesToFileFormat()
    },
    async handleHeic(files) {
      for (let d of files) {
        if (d.name.toLowerCase().indexOf('.heic') !== -1) {
          this.showLoading()
          await this.heicToJpeg(d)
            .then(convertedFile => {
              DataSource.shared.uploadPostMedia(convertedFile).then(saveResponse => {
                if (saveResponse) {
                  for (let file of saveResponse) {
                    this.selectedFile.push({ file, date: '', url: getActivityUploadPreviewBase() + '/' + file })
                  }
                }
              })
            })
            .finally(() => {
              this.hideLoading()
            })
        }
      }
    },
    async heicToJpeg(val) {
      var blobUrl = URL.createObjectURL(val)

      return await fetch(blobUrl)
        .then(res => res.blob())
        .then(blob =>
          heic2any({
            blob,
            toType: 'image/jpeg',
            quality: 1,
          }),
        )
        .then(conversionResult => {
          var url = URL.createObjectURL(conversionResult)
          conversionResult.name = val.name.replace('.heic', '.jpeg')
          conversionResult.url = url
          conversionResult.oriType = 'heic'
          return conversionResult
        })
        .catch(e => {
          console.log(e)
          return e
        })
    },
    handlePushMedia(convertedFile) {
      if (this.isReplace) {
        this.replaceUrl(convertedFile)
      } else {
        this.arrobj_SelectedFiles.push({ file: convertedFile, date: '' })
      }
      // this.$emit("getselectedfiles", this.arrobj_SelectedFiles);
    },
    replace(file, index) {
      if (index !== null) {
        this.replaceIndex = index
      }
      this.isReplace = true
      this.onclickUploadFile()
    },
    replaceUrl(convertedFile) {
      this.isReplace = false
      if (convertedFile) {
        convertedFile.url = URL.createObjectURL(convertedFile)
      }

      if (this.arr_SelectedFileList.length > 0) {
        let arr = []
        arr = this.arrobj_SelectedFiles.map((d, i) => {
          if (i === this.replaceIndex) {
            d.file = convertedFile
          }
          return d
        })
        this.arrobj_SelectedFiles = arr
      }
      this.$forceUpdate()
    },
    convertSelectedFilesToFileFormat() {
      this.convertedFileForInsert = []

      this.arrobj_SelectedFiles.forEach(async images => {
        if (images.file.name === undefined) {
          let url = 'data:' + images.file.type + ';base64,' + images.file.EventFileOriginal
          let fileName = images.file.EventFIleName
          let mimeType = images.file.EventFileType

          this.urltoFile(url, fileName, mimeType)
            .then(file => {
              this.convertedFileForInsert.push(file)
            })
            .finally(() => {
              // this.getImagePreviews();
            })
        } else {
          // images.url = URL.createObjectURL(images);

          if (!this.isNull(images.file.url)) {
            // if (images.name.toLowerCase().indexOf(".heic") !== -1) {
          } else {
            images.file.url = URL.createObjectURL(images.file)
          }

          // images.url = URL.createObjectURL(images);
        }
      })

      this.hideLoading()
    },
    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },
    isWhitelist(file) {
      let temparrstr = file.name.split('.')
      let str_Ext = ('.' + temparrstr[temparrstr.length - 1]).toUpperCase()
      let isWhitelisted = this.arrstr_Whitelist.findIndex(x => x.ext.toUpperCase() === str_Ext) !== -1
      let isValidFile = file.size > 0
      return isWhitelisted && isValidFile
    },
    loadWhitelist() {
      this.arrstr_Whitelist = []

      DataSource.shared.getWhitelist().then(result => {
        if (result.Table) {
          this.arrstr_Whitelist = result.Table
        }
      })
    },
    checkFilesType(eachfile) {
      let fileType = eachfile.type.split('/')

      if (fileType[0] === '') {
        fileType[0] = 'image'
      }

      return fileType[0]
    },
    dragStart(which, ev) {
      ev.dataTransfer.setData('Text', this.id)
      ev.dataTransfer.dropEffect = 'move'
      this.dragging = which

      this.selectedFile.forEach((d, i) => {
        if (i === which) {
          return (d.isArrange = true)
        }
      })
    },
    dragEnd(ev) {
      this.dragging = -1
    },
    dragFinish(to, ev) {
      this.moveItem(this.dragging, to)
      ev.target.style.marginTop = '2px'
      ev.target.style.marginBottom = '2px'

      this.selectedFile.forEach((d, i) => {
        if (i === to) {
          return (d.isArrange = false)
        }
      })
    },
    moveItem(from, to) {
      if (to === -1) {
        this.removeItemAt(from)
      } else {
        this.selectedFile.splice(to, 0, this.selectedFile.splice(from, 1)[0])
      }
    },
    removeItemAt(index) {
      this.arrobj_SelectedFiles.splice(index, 1)
      this.selectedFile.splice(index, 1)
      // this.$emit("getselectedfiles", this.arrobj_SelectedFiles);
      this.$forceUpdate()
    },
    handleArrange() {
      this.isRearrange = !this.isRearrange
    },
    checkIfImage(file) {
      const fileName = file.toLowerCase()
      const fileType = fileName.split('.')[1]
      switch (fileType) {
        // case "image/jpeg":
        // case "image/png":
        // case "image/jpg":
        // case "image/gif":
        case 'jpeg':
        case 'jfif':
        case 'png':
        case 'jpg':
        case 'gif':
        case 'heic':
          return true
        // case "video/mp4":
        //     return "video/mp4";
        default:
          return false
      }
    },
    getFileExtention(file) {
      const fileName = file.toLowerCase()
      const fileType = fileName.split('.')[1]
      return fileType
    },
    triggerClickVideo(videoFile, itemID) {
      if (this.getFileExtention(videoFile.file) === 'pdf') {
        this.videoClick = true
        this.pdfFile = videoFile.url
      } else if ($('.video-thumbnail-' + itemID + ' img').length > 0) {
        this.videoClick = true
        this.videoFile = videoFile.url
        // $(".video-thumbnail-" + itemID + " img").remove();

        // var videoHtml = "";
        // videoHtml += "<video class='media-file-video preview' style='max-width: 100%; height: 100%;' controls autoplay src='" + videoFile.oriPath + "' type='video/mp4' controlsList='nodownload'>";
        // videoHtml += "</video>";
        //
        // if ($(".video-thumbnail-" + itemID + " video").length <= 0) {
        //   $(".video-thumbnail-" + itemID).append(videoHtml);
        //   this.videoClick = false;
        // }
      }
    },
    handleClose() {
      this.videoClick = false
      this.videoFile = null
    },
  },
}
</script>
